export const testimonials = [
    {
      id: 1,
      name: "WRP Renovations Inc.",
      title: "Certified Building Contractor",
      text: "We use H&W Concrete on all of our company projects. Patrick is fair with his pricing and always follows through!",
    },
    {
      id: 2,
      name: "Tony Palmiotti",
      title: "Home Owner",
      text: "Quality work at a very reasonable price! I highly recommend Patrick and his crew. H&W Concrete was a pleasure to work with.",
    },
    {
      id: 3,
      name: "Alex Coyne",
      title: "Home & Business Owner",
      text: "Patrick and his crew at H&W Concrete did a great job! Reliable, honest, and finished ahead of schedule.",
    },
  ];